module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.shouldShowLoginSection()) ? _c('user-login', {
    on: {
      "input": _vm.loginStateChanged
    },
    model: {
      value: (_vm.user),
      callback: function($$v) {
        _vm.user = $$v
      },
      expression: "user"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.shouldShowLoginSection()) ? [_c('email-input', {
    attrs: {
      "disabled": _vm.user.loggedIn
    },
    model: {
      value: (_vm.user.email),
      callback: function($$v) {
        _vm.$set(_vm.user, "email", $$v)
      },
      expression: "user.email"
    }
  })] : _vm._e(), _vm._v(" "), _c('fieldset', [_c('input-with-validation', {
    attrs: {
      "type": "text",
      "label": "First Name",
      "regex": "^.{1,255}",
      "max-length": "255",
      "required": "true",
      "failure-msg": "Please provide your first name",
      "half-width": "true"
    },
    model: {
      value: (_vm.user.firstName),
      callback: function($$v) {
        _vm.$set(_vm.user, "firstName", $$v)
      },
      expression: "user.firstName"
    }
  }), _vm._v(" "), _c('input-with-validation', {
    attrs: {
      "type": "text",
      "label": "Last Name",
      "regex": "^.{1,255}",
      "max-length": "255",
      "required": "true",
      "failure-msg": "Please provide your last name",
      "half-width": "true"
    },
    model: {
      value: (_vm.user.lastName),
      callback: function($$v) {
        _vm.$set(_vm.user, "lastName", $$v)
      },
      expression: "user.lastName"
    }
  })], 1), _vm._v(" "), _c('fieldset', [_c('input-with-validation', {
    attrs: {
      "type": "tel",
      "label": "Mobile Number",
      "regex": "^.{1,255}",
      "max-length": "255",
      "additional-info-show": _vm.isDmnSource,
      "additional-info": "Used for tracking and confirming your booking only",
      "failure-msg": "Please provide a valid mobile number",
      "required": "false"
    },
    model: {
      value: (_vm.user.phone),
      callback: function($$v) {
        _vm.$set(_vm.user, "phone", $$v)
      },
      expression: "user.phone"
    }
  })], 1), _vm._v(" "), (_vm.bookingDetails.shouldShowDobField) ? _c('fieldset', [_c('dob-selection', {
    attrs: {
      "label": "Birthday",
      "required": _vm.bookingDetails.dobRequired,
      "failure-msg": "Please enter a valid date of birth"
    },
    model: {
      value: (_vm.user.dob),
      callback: function($$v) {
        _vm.$set(_vm.user, "dob", $$v)
      },
      expression: "user.dob"
    }
  })], 1) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12f29486","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/userDetailsForm.vue
// module id = 582
// module chunks = 0